/**
 * Legacy /settings route — redirects into the Account hub Preferences tab.
 */
import { Navigate } from "react-router-dom";

export function SettingsPage() {
	return <Navigate to="/account?tab=preferences" replace />;
}
